import React, { useState } from 'react';
import MetaTags from 'react-meta-tags';
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  Col,
  Container,
  Form,
  FormGroup,
  Input,
  Label,
  Row
} from 'reactstrap';
import ApiClient from '../BaseUrl/ApiClient';
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

function UserSubscription() {
  const [email, setEmail] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const [subscriptionStatus, setSubscriptionStatus] = useState('subscribed');
  const [subscriptionStartDate, setSubscriptionStartDate] = useState('');
  const [subscriptionExpiryDate, setSubscriptionExpiryDate] = useState('');
  const [subscriptionMethod, setSubscriptionMethod] = useState('cash');

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!email) {
      toast.error('Please enter an email address');
      return;
    }

    if (!subscriptionStartDate || !subscriptionExpiryDate) {
      toast.error('Please provide start and expiry dates');
      return;
    }

    setIsLoading(true);
    try {
      const payload = {
        subscriptionStatus,
        subscriptionStartDate,
        subscriptionExpiryDate,
        subscriptionMethod
      };

      const response = await ApiClient.post(
        `/admin/subscription/user/${email}`,
        payload,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`
          }
        }
      );

      if (response.data.responseCode === 200) {
        toast.success('User subscribed successfully!');
      } else {
        toast.error(response.data.responseMessage?.join(', ') || 'Failed to subscribe user');
      }
    } catch (error) {
      console.error('Error:', error);
      if (error.response) {
        toast.error(error.response.data.responseMessage?.join(', ') || 'Subscription failed');
      } else {
        toast.error('Network error. Please try again.');
      }
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <React.Fragment>
      <ToastContainer />
      <div className="page-content">
        <MetaTags>
          <title>Subscribe User | Findagram</title>
        </MetaTags>
        <Container fluid>
          <Row>
            <Col lg={12}>
              <Card>
                <CardHeader>
                  <h3>Subscribe User</h3>
                </CardHeader>
                <CardBody>
                  <Form onSubmit={handleSubmit}>
                    {/* Email Field */}
                    <FormGroup>
                      <Row className="align-items-end">
                        <Col lg="12" xs="12" md="12">
                          <Label for="email">Email</Label>
                          <Input
                            type="email"
                            name="email"
                            id="email"
                            placeholder="Enter user email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            required
                          />
                        </Col>
                      </Row>
                    </FormGroup>

                    {/* Additional Subscription Fields */}
                    <FormGroup className="mt-4">
                      <Row>
                        <Col md="6">
                          <Label for="subscriptionStatus">Subscription Status</Label>
                        <Input
                            type="select"
                            id="subscriptionStatus"
                            value={subscriptionStatus}
                            onChange={(e) => setSubscriptionStatus(e.target.value)}
                          >
                            <option value="expired">Expired</option>
                            <option value="subscribed">Subscribed</option>
                            <option value="trial">Trial</option>
                          </Input>
                        </Col>

                        <Col md="6">
                          <Label for="subscriptionMethod">Subscription Method</Label>
                          <Input
                            type="select"
                            id="subscriptionMethod"
                            value={subscriptionMethod}
                            onChange={(e) => setSubscriptionMethod(e.target.value)}
                          >
                            <option value="cash">Cash</option>
                            <option value="stripe">Stripe</option>
                            <option value="e-transfer">E-Transfer</option>
                          </Input>
                        </Col>
                      </Row>
                    </FormGroup>

                    <FormGroup>
                      <Row>
                        <Col md="6">
                          <Label for="subscriptionStartDate">Subscription Start Date</Label>
                          <Input
                            type="date"
                            id="subscriptionStartDate"
                            value={subscriptionStartDate}
                            onChange={(e) => setSubscriptionStartDate(e.target.value)}
                          />
                        </Col>
                        <Col md="6">
                          <Label for="subscriptionExpiryDate">Subscription Expiry Date</Label>
                          <Input
                            type="date"
                            id="subscriptionExpiryDate"
                            value={subscriptionExpiryDate}
                            onChange={(e) => setSubscriptionExpiryDate(e.target.value)}
                          />
                        </Col>
                      </Row>
                    </FormGroup>
                    <div className='d-flex justify-content-end'>
                        <Col lg="3" xs="12" md="5" className="mt-3 mt-md-0 text-end">
                          <Button
                            color="primary"
                            type="submit"
                            disabled={isLoading}
                            className="w-100"
                          >
                            {isLoading ? 'Subscribing...' : 'Subscribe User'}
                          </Button>
                        </Col>
                    </div>
                  </Form>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
}

export default UserSubscription;
